/**
 * Module colour accents (visual refresh 2026-10): plan = teal, recipes =
 * orange, pantry = green, groceries = teal→green. Class strings are spelled
 * out in full so Tailwind's scanner picks them up.
 */
export type Accent = 'teal' | 'orange' | 'green' | 'groceries' | 'neutral';

export interface AccentClasses {
  /** Small solid bar / dot next to a heading. */
  bar: string;
  /** Tinted tile behind an icon, or a soft background wash. */
  soft: string;
  /** Text colour that keeps AA contrast on cream/surface. */
  text: string;
  /** Hover tint for list rows inside an accented card. */
  hover: string;
}

export const ACCENTS: Record<Accent, AccentClasses> = {
  teal: {
    bar: 'bg-brand',
    soft: 'bg-brand-soft',
    text: 'text-brand',
    hover: 'hover:bg-brand-soft/60',
  },
  orange: {
    bar: 'bg-orange',
    soft: 'bg-orange-soft',
    text: 'text-orange-ink',
    hover: 'hover:bg-orange-soft/50',
  },
  green: {
    bar: 'bg-accent',
    soft: 'bg-accent-soft',
    text: 'text-accent-ink',
    hover: 'hover:bg-accent-soft/60',
  },
  groceries: {
    bar: 'bg-gradient-to-b from-brand to-accent',
    soft: 'bg-gradient-to-br from-brand-soft to-accent-soft',
    text: 'text-brand',
    hover: 'hover:bg-accent-soft/50',
  },
  neutral: {
    bar: 'bg-line',
    soft: 'bg-cream',
    text: 'text-brand',
    hover: 'hover:bg-brand-soft/60',
  },
};

/** Which module a route belongs to, for the page-title accent. */
export function accentForPath(pathname: string): Accent {
  if (pathname.startsWith('/recipes') || pathname.startsWith('/import')) return 'orange';
  if (pathname.startsWith('/plan')) return 'teal';
  if (pathname.startsWith('/pantry') || pathname.startsWith('/ingredients')) return 'green';
  if (pathname.startsWith('/groceries') || pathname.startsWith('/stores')) return 'groceries';
  return 'neutral';
}
